import { PinTypes } from '../../domain/pin';

export interface IPinAddRequest  {
    Shared: boolean;
    AdminID: number;
    RelationID: number;
    PinType: PinTypes;

}

export class PinAddRequest  implements IPinAddRequest {
    Shared: boolean;
    AdminID: number;
    RelationID: number;
    PinType: PinTypes;

}
